import dotenv from "dotenv";

// Load environment variables from .env file
dotenv.config();

//console.log("Loaded SERVER_IP:", process.env.NODE_OPTIONS); // Debugging Line

//const port1 = process.env.PORT || 5000; // Default port: 5000
const port1 = 5000; // Default port: 5000

// Check if running in development environment
const isLocalhost = process.env.NODE_ENV === 'development';

// Configure server URL dynamically
const config = {
    serverURL: isLocalhost
        ? `http://localhost:${port1}` // Localhost
       // : `https://${process.env.SERVER_IP || 'md-mall-new.vercel.app'}`, // Production
        : "https://www.mdmall.in",
    };

export { config, port1 };

